import React from "react";

import Badge from "veneer/Badge";
import styled from "veneer/styled";

import {
  MEDIA_ENTRY_APPLICATION,
  MEDIA_ENTRY_CONTENT_GROUP,
  MEDIA_ENTRY_FOLDER,
  MEDIA_ENTRY_USER_CONTENT,
  MEDIA_ENTRY_WEBPAGE,
} from "cortex/ui/src/fleet/constant/mediaLibrary";
import contentGroupIcon from "cortex/ui/static/svg/icon-content-group.svg";
import folderIcon from "cortex/ui/static/svg/icon-folder.svg";
import webPageIcon from "cortex/ui/static/svg/icon-webpage.svg";

interface SpotPreviewProps {
  mimeType?: string;
  numberOfSpots?: number;
  showControls?: boolean;
  type?: string;
  url?: string;
}

const ICON_HEIGHT = 50;

const PreviewImage = styled("img")({
  borderRadius: 2,
  height: "auto",
  maxHeight: ICON_HEIGHT * 1.5,
  maxWidth: "100%",
  width: "auto",
});

const PreviewIcon = styled(PreviewImage)({
  height: ICON_HEIGHT,
});

const PreviewVideo = styled("video")({
  borderRadius: 2,
  height: "auto",
  maxHeight: ICON_HEIGHT * 1.5,
  maxWidth: "100%",
  width: "auto",
});

export function SpotPreview({
  mimeType = "",
  numberOfSpots = 0,
  showControls = true,
  type = "",
  url = "",
}: SpotPreviewProps) {
  const renderImagePreview = (imageUrl: string) => {
    return <PreviewImage alt="" src={imageUrl} />;
  };

  const renderIconPreview = (iconUrl: string) => {
    return <PreviewIcon src={iconUrl} />;
  };

  const renderContentGroupPreview = (spots: number) => {
    return (
      <Badge badgeContent={spots} color="green">
        {renderIconPreview(contentGroupIcon)}
      </Badge>
    );
  };

  const renderContentPreview = () => {
    if (!mimeType || !url) {
      return <div>No Preview</div>;
    }

    if (mimeType === MEDIA_ENTRY_WEBPAGE) {
      return renderIconPreview(webPageIcon);
    }

    if (mimeType.startsWith("image")) {
      return renderImagePreview(url);
    }

    if (mimeType.startsWith("video")) {
      return (
        <PreviewVideo controls={showControls} key={url} preload="false">
          <source src={url} />
        </PreviewVideo>
      );
    }

    return null;
  };

  switch (type) {
    case MEDIA_ENTRY_CONTENT_GROUP:
      return renderContentGroupPreview(numberOfSpots);

    case MEDIA_ENTRY_APPLICATION:
      return renderImagePreview(url);

    case MEDIA_ENTRY_FOLDER:
      return renderIconPreview(folderIcon);

    case MEDIA_ENTRY_USER_CONTENT:
      return renderContentPreview();

    case MEDIA_ENTRY_WEBPAGE:
      return renderIconPreview(webPageIcon);

    default:
      return <div>No Preview</div>;
  }
}
